module.exports = __webpack_public_path__ + "static/media/img_info.26c1e438.png";